<template>
  <!-- target: mf_index_assetManage_productManage -->
    <div
        id="mf-index-assetManage-productManage"
        v-loading="submitLoading"
        class="mf-index-assetManage-productManage v-container"
        element-loading-text="提交中..."
    >
        <div>
            <main class="pm-main">
                <section class="pm-card pm-panel">
                    <h1 class="pm-page-title">产品信息</h1>

                    <div class="pm-section-title">基础信息</div>
                    <div class="pm-form-row">
                        <div class="pm-label"><span class="pm-required">*</span>产品名称</div>
                        <div class="pm-content">
                            <el-input
                                v-model.trim="productForm.name"
                                placeholder="请输入产品名称"
                                style="width: 600px;"
                            ></el-input>
                        </div>
                    </div>
                    <div class="pm-form-row">
                        <div class="pm-label"><span class="pm-required">*</span>行业</div>
                        <div class="pm-content">
                            <el-cascader
                                ref="industryCascader"
                                clearable
                                v-model="productForm.category"
                                :options="categories"
                                :props="props"
                                :disabled="isIndustryCascaderDisabled"
                                style="width: 600px;"
                                placeholder="请选择行业类目"
                                @change="handleChangeCategory"
                            ></el-cascader>
                        </div>
                    </div>

                    <div class="pm-form-row">
                        <div class="pm-label"><span class="pm-required">*</span>保存校验</div>
                        <div class="pm-content">
                           <el-switch style="margin-top: 12px;"
                                v-model="productForm.skip_rule"
                            >
                            </el-switch>
                        </div>
                    </div>

                    <div class="pm-form-row" v-if="showIaa">
                        <div class="pm-label"><span class="pm-required">*</span>是否IAA产品</div>
                        <div class="pm-content">
                           <el-switch style="margin-top: 12px;"
                                v-model="productForm.is_iaa"
                            >
                            </el-switch>
                        </div>
                    </div>

                    <div v-if="productEnabled">
                        <div v-if="industryRuleVisible" class="pm-industry-rule">
                            <strong>填写规则：</strong>{{industryRuleText}}
                        </div>

                        <div v-if="showQuickVendorArea" class="pm-quick-vendor-area">
                            <div class="pm-form-row">
                                <div class="pm-label"><span class="pm-required">*</span>快应用上架厂商</div>
                                <div class="pm-content">
                                    <div class="pm-checkbox-group">
                                        <label v-for="vendor in quickVendorOptions" :key="vendor.value" class="pm-checkbox-item">
                                            <input type="checkbox" :value="vendor.value" v-model="productForm.app_delivery_info.quick_app_vendor" />
                                            {{vendor.label}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="showDeviceArea" class="pm-device-area">

                            <div class="pm-device-section">
                                <div class="pm-section-title">软件著作</div>
                                <div class="pm-asset-card">
                                    <div class="pm-form-row" style="padding-top: 24px;">
                                        <div class="pm-label">
                                            软件著作
                                        </div>
                                        <div class="pm-content">
                                            <upload-img
                                                @delete="onRemove_soft"
                                                @upload="onSuccess_soft"
                                                sign="qualification"
                                                :multiple="true"
                                                :imgs="fileList_soft"
                                            ></upload-img>
                                            <!-- <el-upload :on-success="onSuccess_soft" action="/resource?type=3" list-type="picture" class="custom-upload-list"
                                                :file-list="fileList_soft" :before-upload="before_soft" :on-remove="onRemove_soft" :on-preview="handleSoftPreview">
                                                <div style="display: flex;align-items: center;">
                                                    <i class="icon-upload"></i>
                                                    <div>
                                                        <el-button class="el-upload__text" type="primary">点击上传软件著作</el-button>
                                                    </div>
                                                </div>
                                            </el-upload> -->
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="showAndroidSection" class="pm-device-section">
                                <div class="pm-section-title">Android 设备</div>
                                <div class="pm-asset-card">
                                    <div class="pm-asset-head">
                                        <span class="pm-asset-head-title">Android 包名、{{showAndroidLinkField ? '链接与 ' : ''}}DP</span>
                                    </div>
                                    <div class="pm-form-row">
                                        <div class="pm-label">
                                            Android 包名
                                        </div>
                                        <div class="pm-content">
                                            <el-input v-model.trim="productForm.app_delivery_info.android.package_name" placeholder="请输入 Android 包名"></el-input>
                                        </div>
                                    </div>
                                    <div v-if="showAndroidLinkField" class="pm-form-row">
                                        <div class="pm-label">
                                            下载/商店链接
                                        </div>
                                        <div class="pm-content">
                                            <el-input v-model.trim="productForm.app_delivery_info.android.download_url" placeholder="请输入下载链接或商店链接"></el-input>
                                        </div>
                                    </div>
                                    <div class="pm-form-row">
                                        <div class="pm-label">
                                            DP 信息
                                        </div>
                                        <div class="pm-content">
                                            <table class="pm-dp-table">
                                                <thead>
                                                <tr>
                                                    <th>DP Demo</th>
                                                    <th style="width: 42%;">DP Schema</th>
                                                    <th style="width: 68px;">操作</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(item, index) in productForm.app_delivery_info.android.deeplinks" :key="'android-dp-' + index">
                                                    <td>
                                                        <textarea v-model.trim="item.demo" @input="handleDpDemoInput('android', item)" @change="handleDpDemoInput('android', item)" placeholder="请输入完整 DP Demo"></textarea>
                                                    </td>
                                                    <td>
                                                        <input :value="item.schema" placeholder="根据 DP Demo 自动带出" disabled />
                                                    </td>
                                                    <td>
                                                        <button type="button" class="pm-dp-delete-btn" @click="removeDp('android', index)">删除</button>
                                                    </td>
                                                </tr>
                                                <tr class="pm-dp-add-row">
                                                    <td colspan="3">
                                                        <button type="button" class="pm-dp-add-btn" @click="addDp('android')">+ 添加 DP</button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="showIosSection" class="pm-device-section">
                                <div class="pm-section-title">iOS 设备</div>
                                <div class="pm-asset-card">
                                    <div class="pm-asset-head">
                                        <span class="pm-asset-head-title">iOS 包名、链接与 DP</span>
                                    </div>
                                    <div class="pm-form-row">
                                        <div class="pm-label">
                                            iOS 包名
                                        </div>
                                        <div class="pm-content">
                                            <el-input v-model.trim="productForm.app_delivery_info.ios.package_name" placeholder="请输入 iOS 包名"></el-input>
                                        </div>
                                    </div>
                                    <div class="pm-form-row">
                                        <div class="pm-label">
                                            下载/商店链接
                                        </div>
                                        <div class="pm-content">
                                            <el-input v-model.trim="productForm.app_delivery_info.ios.download_url" placeholder="请输入 App Store 或商店链接"></el-input>
                                        </div>
                                    </div>
                                    <div class="pm-form-row">
                                        <div class="pm-label">
                                            选择方式
                                        </div>
                                        <div class="pm-content" style="margin-top: 12px;">
                                            <el-radio-group v-model="productForm.app_delivery_info.ios.link_type" @change="handleIosPathModeChange">
                                                <el-radio label="universal_link">Universal Link</el-radio>
                                                <el-radio label="deeplink">DP 信息</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </div>
                                    <div v-if="showIosUniversalLinkField" class="pm-form-row">
                                        <div class="pm-label">
                                            Universal Link
                                        </div>
                                        <div class="pm-content">
                                            <el-input v-model.trim="productForm.app_delivery_info.ios.universal_link" placeholder="请输入 iOS Universal Link"></el-input>
                                        </div>
                                    </div>
                                    <div v-if="showIosDpField" class="pm-form-row">
                                        <div class="pm-label">
                                            DP 信息
                                        </div>
                                        <div class="pm-content">
                                            <table class="pm-dp-table">
                                                <thead>
                                                <tr>
                                                    <th>DP Demo</th>
                                                    <th style="width: 42%;">DP Schema</th>
                                                    <th style="width: 68px;">操作</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(item, index) in productForm.app_delivery_info.ios.deeplinks" :key="'ios-dp-' + index">
                                                    <td>
                                                        <textarea v-model.trim="item.demo" @input="handleDpDemoInput('ios', item)" @change="handleDpDemoInput('ios', item)" placeholder="请输入完整 DP Demo"></textarea>
                                                    </td>
                                                    <td>
                                                        <input :value="item.schema" placeholder="根据 DP Demo 自动带出" disabled />
                                                    </td>
                                                    <td>
                                                        <button type="button" class="pm-dp-delete-btn" @click="removeDp('ios', index)">删除</button>
                                                    </td>
                                                </tr>
                                                <tr class="pm-dp-add-row">
                                                    <td colspan="3">
                                                        <button type="button" class="pm-dp-add-btn" @click="addDp('ios')">+ 添加 DP</button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="showAuditRecordSection" class="pm-audit-record-section">
                            <div class="pm-section-title">最新审核记录</div>
                            <div class="pm-asset-table-row">
                                <div class="pm-asset-table-label">已通过记录</div>
                                <div class="pm-table-wrap">
                                    <el-table
                                        class="pm-audit-record-el-table"
                                        size="medium"
                                        :data="auditRecordTableData"
                                        :span-method="auditRecordsSpanMethod"
                                        :header-cell-style="{background:'#f8faff',color:'#7c8595'}"
                                    >
                                        <el-table-column prop="productName" label="产品名称" width="150"></el-table-column>
                                        <el-table-column prop="platform" label="平台" width="74"></el-table-column>
                                        <el-table-column prop="packageName" label="包名" width="150" show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="link" label="下载/商店链接" width="240" show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="schemas" label="DP Schema" min-width="250">
                                            <template slot-scope="scope">
                                                <span
                                                    v-for="(schema, schemaIndex) in scope.row.schemas"
                                                    :key="schema.name + '-audit-' + schemaIndex"
                                                >
                                                    <span class="pm-schema-link" @click="showDemoPopover($event, schema.demo)">{{schema.name}}</span><span v-if="schemaIndex < scope.row.schemas.length - 1">, </span>
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="statusText" label="状态" width="78">
                                            <template slot-scope="scope">
                                                <span class="pm-tag" :class="'is-' + scope.row.statusType">{{scope.row.statusText}}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pm-divider"></div>
                    <div class="pm-btn-row">
                        <button
                            type="button"
                            class="pm-btn pm-btn-primary"
                            :class="{ 'is-loading': submitLoading }"
                            :disabled="submitLoading"
                            @click="handleSave"
                        >
                            <i v-if="submitLoading" class="el-icon-loading pm-btn__loading-icon"></i>
                            <span>{{submitLoading ? '提交中...' : '保存并提交审核'}}</span>
                        </button>
                        <button type="button" class="pm-btn pm-btn-danger" :disabled="submitLoading" @click="handleCancelEdit">取消</button>
                    </div>
                </section>
            </main>
        </div>

        <div
            v-show="demoPopover.visible"
            class="pm-demo-popover"
            :style="{left: demoPopover.left + 'px', top: demoPopover.top + 'px'}"
        >
            <div class="pm-demo-popover-title">DP Demo</div>
            <div>{{demoPopover.text}}</div>
        </div>
    </div>

</template>

<script>
    import Request from '@/core/QuRequest';
    import UploadImg from '@/components/UploadImgOnly';

    const req = new Request();

    function createDpItem(schema, demo) {
        return {
            schema: schema || '',
            demo: demo || ''
        };
    }

    function inferSchemaFromDemo(demo) {
        var value = (demo || '').trim();
        var match;

        if (!value) {
            return '';
        }

        match = value.match(/^([a-zA-Z][a-zA-Z0-9+.-]*:\/\/)/);
        if (match && match[1]) {
            return match[1];
        }

        match = value.match(/^([a-zA-Z][a-zA-Z0-9+.-]*):/);
        if (match && match[1]) {
            return match[1] + '://';
        }

        return '';
    }

    function getLeafCategoryLabel(categoryPath, categoryOptions) {
        var level = categoryOptions || [];
        var current = null;
        var i;
        var j;
        var found;

        if (!Array.isArray(categoryPath) || !categoryPath.length) {
            return '';
        }

        for (i = 0; i < categoryPath.length; i++) {
            found = null;
            for (j = 0; j < level.length; j++) {
                if (String(level[j].value) === String(categoryPath[i])) {
                    found = level[j];
                    break;
                }
            }

            if (!found) {
                return '';
            }

            current = found;
            level = found.child || [];
        }

        return current ? current.name : '';
    }

    function getCategoryLabelPath(categoryPath, categoryOptions) {
        var level = categoryOptions || [];
        var names = [];
        var i;
        var j;
        var found;

        if (!Array.isArray(categoryPath) || !categoryPath.length) {
            return '';
        }

        for (i = 0; i < categoryPath.length; i++) {
            found = null;
            for (j = 0; j < level.length; j++) {
                if (String(level[j].value) === String(categoryPath[i])) {
                    found = level[j];
                    break;
                }
            }

            if (!found) {
                return '';
            }

            names.push(found.name);
            level = found.child || [];
        }

        return names.join(' / ');
    }

    function getCategoryLabelPathByDash(categoryPath, categoryOptions) {
        var level = categoryOptions || [];
        var names = [];
        var i;
        var j;
        var found;

        if (!Array.isArray(categoryPath) || !categoryPath.length) {
            return '';
        }

        for (i = 0; i < categoryPath.length; i++) {
            found = null;
            for (j = 0; j < level.length; j++) {
                if (String(level[j].value) === String(categoryPath[i])) {
                    found = level[j];
                    break;
                }
            }

            if (!found) {
                return '';
            }

            names.push(found.name);
            level = found.child || [];
        }

        return names.join('-');
    }

    function safeTrim(value) {
        if (typeof value === 'string') return value.trim();
        if (value === undefined || value === null) return '';
        return String(value).trim();
    }

    function escapeHtml(value) {
        return safeTrim(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function buildWarningMessageHtml(title, warningText) {
        var safeTitle = escapeHtml(title);
        var safeWarning = escapeHtml(warningText).replace(/\r?\n/g, '<br>');

        return safeTitle + '<br>' + safeWarning;
    }

    function findCategoryPathByLeafId(leafId, categoryOptions) {
        var targetId = leafId == null ? '' : String(leafId);
        var matchedPath = [];

        function walk(nodes, parentPath) {
            var list = nodes || [];
            var i;
            var node;
            var currentPath;

            for (i = 0; i < list.length; i++) {
                node = list[i];
                currentPath = parentPath.concat([node.value]);

                if (String(node.value) === targetId) {
                    matchedPath = currentPath;
                    return true;
                }

                if (node.child && node.child.length && walk(node.child, currentPath)) {
                    return true;
                }
            }

            return false;
        }

        if (!targetId) {
            return [];
        }

        walk(categoryOptions || [], []);
        return matchedPath;
    }

    function normalizeSchemaList(deeplinks) {
        return (deeplinks || []).filter(function (item) {
            return item && (!!((item.schema || item.name || '').trim()) || !!((item.demo || '').trim()));
        }).map(function (item) {
            var schema = (item.schema || item.name || '').trim();
            var demo = (item.demo || '').trim();

            if (!schema && demo) {
                schema = inferSchemaFromDemo(demo);
            }

            return {
                name: schema,
                schema: schema,
                demo: demo
            };
        });
    }

    function createFormDpList(deeplinks) {
        return normalizeSchemaList(deeplinks).map(function (item) {
            return createDpItem(item.schema, item.demo);
        });
    }

    function hasPlatformDeliveryData(packageName, deliveryInfo) {
        var info = deliveryInfo || {};

        return !!((packageName || '').trim()
            || (info.download_url || '').trim()
            || (info.universal_link || '').trim()
            || normalizeSchemaList(info.deeplinks).length);
    }

    function getProductStatusMeta(status) {
        if (String(status) === '0') {
            return {
                text: '通过',
                type: 'ok'
            };
        }

        return {
            text: '待审核',
            type: 'pending'
        };
    }

    function normalizeAppDeliveryInfo(product) {
        var appDeliveryInfo = product.app_delivery_info || {};
        var androidInfo = appDeliveryInfo.android || {};
        var iosInfo = appDeliveryInfo.ios || {};

        return {
            android: {
                package_name: (product.android_package_name || androidInfo.package_name || '').trim(),
                download_url: (androidInfo.download_url || '').trim(),
                link_type: (androidInfo.link_type || 'deeplink').trim(),
                deeplinks: normalizeSchemaList(androidInfo.deeplinks),
                universal_link: (androidInfo.universal_link || '').trim()
            },
            ios: {
                package_name: (product.ios_package_name || iosInfo.package_name || '').trim(),
                download_url: (iosInfo.download_url || '').trim(),
                link_type: (iosInfo.link_type || 'universal_link').trim(),
                deeplinks: normalizeSchemaList(iosInfo.deeplinks),
                universal_link: (iosInfo.universal_link || '').trim()
            },
            quick_app_vendor: [].concat(appDeliveryInfo.quick_app_vendor || [])
        };
    }

    // function isTargetInside(target, selector) {
    //     return $(target).closest(selector).length > 0;
    // }

    function detectIndustryMode(categoryPath, categoryOptions, fallbackIndustryText) {
        if(categoryPath && Array.isArray(categoryPath) && categoryPath.length > 0) {
            var cate = String(categoryPath[categoryPath.length - 1]);
            if(cate.indexOf('100103') === 0) {
                return 'fast-app'
            } else if(cate.indexOf('100') === 0) {
                return 'app-download'
            } else {
                return 'non-app'
            }
        } else {
            return 'empty';
        }
    }

    function detectIndustryPrimaryGroup(categoryPath, categoryOptions, fallbackIndustryText) {
        var industryMode = detectIndustryMode(categoryPath, categoryOptions, fallbackIndustryText);

        if (industryMode === 'fast-app' || industryMode === 'app-download') {
            return 'app-download';
        }
        if (industryMode === 'non-app') {
            return 'non-app';
        }
        return 'empty';
    }

    function detectIndustrySecondaryGroup(categoryPath, categoryOptions, fallbackIndustryText) {
        var industryMode = detectIndustryMode(categoryPath, categoryOptions, fallbackIndustryText);

        if (industryMode === 'fast-app') {
            return 'fast-app';
        }
        if (industryMode === 'app-download') {
            return 'non-fast-app';
        }
        return 'empty';
    }

    function getCategoryChangeBlockedMessage(originalCategoryPath, nextCategoryPath, categoryOptions) {
        var originalPrimaryGroup;
        var nextPrimaryGroup;
        var originalSecondaryGroup;
        var nextSecondaryGroup;

        if (!Array.isArray(originalCategoryPath) || !originalCategoryPath.length) {
            return '';
        }

        if (!Array.isArray(nextCategoryPath) || !nextCategoryPath.length) {
            return '';
        }

        originalPrimaryGroup = detectIndustryPrimaryGroup(originalCategoryPath, categoryOptions);
        nextPrimaryGroup = detectIndustryPrimaryGroup(nextCategoryPath, categoryOptions);

        if (
            originalPrimaryGroup !== 'empty' &&
            nextPrimaryGroup !== 'empty' &&
            originalPrimaryGroup !== nextPrimaryGroup
        ) {
            return '一级分类“应用下载”和“非应用下载”不可相互切换，请重新选择。';
        }

        originalSecondaryGroup = detectIndustrySecondaryGroup(originalCategoryPath, categoryOptions);
        nextSecondaryGroup = detectIndustrySecondaryGroup(nextCategoryPath, categoryOptions);

        if (
            originalSecondaryGroup !== 'empty' &&
            nextSecondaryGroup !== 'empty' &&
            originalSecondaryGroup !== nextSecondaryGroup
        ) {
            return '二级分类“快应用”和“非快应用”不可相互切换，请重新选择。';
        }

        return '';
    }

    function createEmptyProductForm() {
        return {
            name: '',
            category: [],
            industry_id: '',
            industry_name: '',
            industryText: '',
            app_delivery_info: {
                android: {
                    package_name: '',
                    download_url: '',
                    link_type: 'deeplink',
                    deeplinks: [],
                    universal_link: ''
                },
                ios: {
                    package_name: '',
                    download_url: '',
                    link_type: 'universal_link',
                    deeplinks: [],
                    universal_link: ''
                },
                quick_app_vendor: []
            },
            skip_rule: true,
        };
    }

    function flattenMyProducts(products) {
        var rows = [];

        (products || []).forEach(function (product) {
            var appDeliveryInfo = product.app_delivery_info || {};
            var androidPackageName = product.android_package_name;
            var iosPackageName = product.ios_package_name;
            var productRows = [];
            var statusMeta = {};

            if (String(product.audit_status) === '0') {
                statusMeta = {
                    text: '待审核',
                    type: 'pending'
                };
            }
            else if (String(product.audit_status) === '2') {
                statusMeta = {
                    text: '驳回',
                    type: 'reject'
                };
            }
            else if (String(product.status) === '0') {
                statusMeta = {
                    text: '有效',
                    type: 'ok'
                };
            }
            else {
                statusMeta = {
                    text: '无效',
                    type: 'invalid'
                };
            }

            if (androidPackageName) {
                productRows.push({
                    productId: product.id,
                    name: product.name,
                    productIndustry: product.industry,
                    productRowSpan: 0,
                    productRef: product,
                    platform: 'Android',
                    packageName: androidPackageName,
                    schemas: (appDeliveryInfo.android && appDeliveryInfo.android.deeplinks) || [],
                    statusText: statusMeta.text,
                    statusType: statusMeta.type,
                    actionType: product.actionType,
                    operator: product.operator,
                    auditReason: product.audit_reason,
                    canEdit: product.can_edit === 1,
                });
            }

            if (iosPackageName) {
                productRows.push({
                    productId: product.id,
                    name: product.name,
                    productIndustry: product.industry,
                    productRowSpan: 0,
                    productRef: product,
                    platform: 'iOS',
                    packageName: iosPackageName,
                    schemas: (appDeliveryInfo.ios && appDeliveryInfo.ios.deeplinks) || [],
                    statusText: statusMeta.text,
                    statusType: statusMeta.type,
                    actionType: product.actionType,
                    operator: product.operator,
                    auditReason: product.audit_reason,
                    canEdit: product.can_edit === 1,
                });
            }

            if (!productRows.length) {
                productRows.push({
                    productId: product.id,
                    name: product.name,
                    productIndustry: product.industry,
                    productRowSpan: 1,
                    productRef: product,
                    platform: '--',
                    packageName: '--',
                    schemas: [],
                    statusText: statusMeta.text,
                    statusType: statusMeta.type,
                    actionType: product.actionType,
                    operator: product.operator,
                    auditReason: product.audit_reason,
                    canEdit: product.can_edit === 1,
                });
            }

            productRows[0].productRowSpan = productRows.length;
            rows = rows.concat(productRows);
        });

        return rows;
    }

    function flattenAuditRecords(records, productName) {
        return (records || []).map(function (row, index, list) {
            return {
                productName: row.name || '',
                productRowSpan: index === 0 ? list.length : 0,
                platform: row.platform,
                packageName: row.packageName,
                link: row.link,
                schemas: row.schemas || [],
                statusText: '通过',
                statusType: 'ok'
            };
        });
    }

    function buildFormFromProduct(product, categoryOptions) {
        var form = createEmptyProductForm();
        var appDeliveryInfo;
        var androidInfo;
        var iosInfo;

        if (!product) {
            return createEmptyProductForm();
        }

        appDeliveryInfo = normalizeAppDeliveryInfo(product);
        androidInfo = appDeliveryInfo.android || {};
        iosInfo = appDeliveryInfo.ios || {};

        form.name = product.name || '';
        form.category = findCategoryPathByLeafId(product.category, categoryOptions);
        form.app_delivery_info.android.package_name = androidInfo.package_name || '';
        form.app_delivery_info.android.download_url = androidInfo.download_url || '';
        form.app_delivery_info.android.link_type = androidInfo.link_type || 'deeplink';
        form.app_delivery_info.android.deeplinks = createFormDpList(androidInfo.deeplinks);
        form.app_delivery_info.android.universal_link = androidInfo.universal_link || '';
        form.app_delivery_info.ios.package_name = iosInfo.package_name || '';
        form.app_delivery_info.ios.download_url = iosInfo.download_url || '';
        form.app_delivery_info.ios.link_type = iosInfo.link_type || (iosInfo.universal_link ? 'universal_link' : 'deeplink');
        form.app_delivery_info.ios.universal_link = iosInfo.universal_link || '';
        form.app_delivery_info.ios.deeplinks = createFormDpList(iosInfo.deeplinks);
        form.app_delivery_info.quick_app_vendor = [].concat(appDeliveryInfo.quick_app_vendor || []);
        form.is_iaa = product.is_iaa === 1;
        form.skip_rule = product.skip_rule !== 1;

        return form;
    }

    function buildAuditRecordsFromProduct(product) {
        var appDeliveryInfo;
        var androidInfo;
        var iosInfo;
        var records = [];

        if (!product) {
            return [];
        }

        appDeliveryInfo = normalizeAppDeliveryInfo(product);
        androidInfo = appDeliveryInfo.android || {};
        iosInfo = appDeliveryInfo.ios || {};

        if (product.android_package_name || androidInfo.download_url || (androidInfo.deeplinks && androidInfo.deeplinks.length)) {
            records.push({
                name: product.name,
                platform: 'Android',
                packageName: product.android_package_name || '--',
                link: androidInfo.download_url || '--',
                schemas: normalizeSchemaList(androidInfo.deeplinks)
            });
        }

        if (product.ios_package_name || iosInfo.download_url || iosInfo.universal_link || (iosInfo.deeplinks && iosInfo.deeplinks.length)) {
            records.push({
                name: product.name,
                platform: 'iOS',
                packageName: product.ios_package_name || '--',
                link: iosInfo.download_url || iosInfo.universal_link || '--',
                schemas: normalizeSchemaList(iosInfo.deeplinks)
            });
        }

        return records;
    }

    function getFilledDpList(dpList) {
        return (dpList || []).filter(function (item) {
            return !!((item.schema || '').trim() || (item.demo || '').trim());
        });
    }

    function getIndustryPayloadMeta(categoryPath, categoryOptions) {
        var leafId = '';
        var categoryNamePath = getCategoryLabelPathByDash(categoryPath, categoryOptions);

        if (Array.isArray(categoryPath) && categoryPath.length) {
            leafId = categoryPath[categoryPath.length - 1];
        }

        return {
            id: leafId || '',
            name: categoryNamePath || ''
        };
    }

    function buildSubmitPayload(form, categoryOptions, fileListSoft, industryMode) {
        var androidInfo = (form.app_delivery_info && form.app_delivery_info.android) || {};
        var iosInfo = (form.app_delivery_info && form.app_delivery_info.ios) || {};
        var quickAppVendor = (form.app_delivery_info && form.app_delivery_info.quick_app_vendor) || [];
        var industryMeta = getIndustryPayloadMeta(form.category, categoryOptions || []);

        const payload = {
            name: (form.name || '').trim(),
            // industry_id: Number(industryMeta.id || form.industry_id || ''),
            // industry_name: industryMeta.name || form.industry_name || industryLabel || '',
            android_package_name: androidInfo.package_name || '',
            ios_package_name: iosInfo.package_name || '',
            category: Number(industryMeta.id || form.industry_id || ''),
            copyright_imgs: fileListSoft || [],
            // copyright_imgs: (fileListSoft || []).map(function (item) {
            //     return item.url;
            // }).filter(function (url) {
            //     return !!url;
            // }),
            app_delivery_info: {
                android: {
                    download_url: (androidInfo.download_url || '').trim(),
                    link_type: (androidInfo.link_type || 'deeplink').trim(),
                    deeplinks: getFilledDpList(androidInfo.deeplinks).map(function (item) {
                        return {
                            schema: (item.schema || '').trim(),
                            demo: (item.demo || '').trim()
                        };
                    }),
                    universal_link: (androidInfo.universal_link || '').trim()
                },
                ios: {
                    download_url: (iosInfo.download_url || '').trim(),
                    link_type: (iosInfo.link_type || 'universal_link').trim(),
                    deeplinks: getFilledDpList(iosInfo.deeplinks).map(function (item) {
                        return {
                            schema: (item.schema || '').trim(),
                            demo: (item.demo || '').trim()
                        };
                    }),
                    universal_link: (iosInfo.universal_link || '').trim()
                },
                quick_app_vendor: quickAppVendor.slice()
            },
            is_iaa: form.is_iaa === true ? 1 : 0,
            skip_rule: form.skip_rule === true ? 0 : 1,
        };

        if(!['fast-app', 'app-download'].includes(industryMode)) {
            delete payload.app_delivery_info
            delete payload.copyright_imgs
            delete payload.android_package_name
            delete payload.ios_package_name
        }

        return payload
    }

export default {
    name: 'OperationProductManagePage',
    components: {
        UploadImg
    },
    props: {
        product: {
            type: Object,
            required: true,
            default() {
                return {};
            },
        },

        isEdit: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    data () {
        return {
            currentProductId: '',
            originalCategory: [],
            searchForm: {
                packageName: '',
                productName: ''
            },
            searched: false,
            searchSource: [],
            searchResults: [],
            myProducts: [],
            productForm: createEmptyProductForm(),
            auditRecords: [],
            quickVendorOptions: [
                {label: '华为', value: 'huawei'},
                {label: '荣耀', value: 'honor'},
                {label: '小米', value: 'xiaomi'},
                {label: 'OPPO', value: 'oppo'},
                {label: 'vivo', value: 'vivo'}
            ],
            demoPopover: {
                visible: false,
                text: '',
                left: 0,
                top: 0
            },
            categories: [],
            props: {
                value: 'value',
                label: 'name',
                children: 'child'
            },
            submitLoading: false,
            productEnabled: false,
            submitPayload: null,
            submitPayloadText: '',
            fileList_soft: []
        };
    },
    watch: {
        product: {
            handler(v) {
                this.syncPanelState();
            },
            deep: true,
            immediate: true,
        },
        isEdit() {
            this.syncPanelState();
        },
    },
    computed: {
        myProductsList () {
            return flattenMyProducts(this.myProducts)
        },
        isIndustryCascaderDisabled () {
            return !(this.productForm.name || '').trim();
        },
        industryMode () {
            return detectIndustryMode(this.productForm.category, this.categories, this.productForm.industryText);
        },
        industryLeafLabel () {
            return getLeafCategoryLabel(this.productForm.category, this.categories) || this.productForm.industryText || '';
        },
        industryRuleVisible () {
            return this.industryMode !== 'empty';
        },
        industryRuleText () {
            if (this.industryMode === 'non-app') {
                return '当前行业为非应用下载（含小程序、线索收集等），包名、下载/商店链接和 DP 均不需要填写。';
            }
            if (this.industryMode === 'fast-app') {
                return '当前行业为应用下载（快应用），Android 包名必填；不展示 iOS 包名；无下载/商店链接；Android DP Schema 与 DP Demo 必填，可多组。';
            }
            return '当前行业为应用下载（非快应用），Android/iOS包名至少填写一个；填写某端包名后，该端下载/商店链接必填；iOS 侧 Universal Link 与 DP 信息二选一。';
        },
        dpMaintainTip () {
            if (this.industryMode !== 'app-download') {
                return '';
            }
            return 'ADV 侧投放时，创意若填写 DP，在产品未维护 DP Schema 前不允许任意填写 DP，请先维护该产品对应的 DP Schema。';
        },
        iosDpRelationTip () {
            if (this.industryMode !== 'app-download') {
                return '';
            }
            return 'iOS 新增 Universal Link 字段，Universal Link 与 DP 信息通过单选进行二选一。';
        },
        showQuickVendorArea () {
            return this.industryMode === 'fast-app';
        },
        showDeviceArea () {
            return this.industryMode === 'app-download' || this.industryMode === 'fast-app';
        },
        showIaa () {
            return this.industryMode === 'app-download';
        },
        showAndroidSection () {
            return this.showDeviceArea;
        },
        showAndroidLinkField () {
            return this.industryMode === 'app-download';
        },
        showIosSection () {
            return this.industryMode === 'app-download';
        },
        showIosUniversalLinkField () {
            return this.showIosSection && this.productForm.app_delivery_info.ios.link_type === 'universal_link';
        },
        showIosDpField () {
            return this.showIosSection && this.productForm.app_delivery_info.ios.link_type === 'deeplink';
        },
        showAuditRecordSection () {
            return this.isEdit && this.showDeviceArea && this.auditRecords.length > 0;
        },
        auditRecordTableData () {
            return flattenAuditRecords(this.auditRecords, this.productForm.name);
        },
        // requiredMarkers () {
        //     var androidFilled = !!(this.productForm.app_delivery_info.android.package_name || '').trim();
        //     var iosFilled = !!(this.productForm.app_delivery_info.ios.package_name || '').trim();
        //     var isFastApp = this.industryMode === 'fast-app';
        //     var isAppDownload = this.industryMode === 'app-download';
        //     var packagePairRequired = isAppDownload && !androidFilled && !iosFilled;
        //     var iosLinkType = this.productForm.app_delivery_info.ios.link_type || 'universal_link';

        //     return {
        //         androidPackage: isFastApp || packagePairRequired,
        //         iosPackage: packagePairRequired,
        //         androidLink: isAppDownload && androidFilled,
        //         androidDp: isFastApp,
        //         iosLink: isAppDownload && iosFilled,
        //         iosDp: isAppDownload && iosFilled && iosLinkType === 'deeplink',
        //         iosUniversalLink: isAppDownload && iosFilled && iosLinkType === 'universal_link'
        //     };
        // },
        androidDpRows () {
            if (!this.productForm.app_delivery_info.android.deeplinks.length) {
                return [createDpItem('', '')];
            }
            return this.productForm.app_delivery_info.android.deeplinks;
        },
        iosDpRows () {
            if (!this.productForm.app_delivery_info.ios.deeplinks.length) {
                return [createDpItem('', '')];
            }
            return this.productForm.app_delivery_info.ios.deeplinks;
        }
    },
    created () {
        this.initPage();
    },
    mounted () {
        // document.addEventListener('click', this.handleDocumentClick);
    },
    beforeDestroy () {
        // document.removeEventListener('click', this.handleDocumentClick);
    },
    methods: {
        initPage () {
            this.getCategories();
        },
        before_soft (file) {
            let type = file.type.split('/').pop()
            const isType = 'gif|jpeg|jpg|png'.indexOf(type) >= 0;
            if (!isType) {
                this.$message.error('文件可能选择可能不正确，请检查！')
            }
            return isType
        },
        onSuccess_soft (val) {
            this.fileList_soft = val.imgs || [];
            // if (!res.id || res.id <= 0) {
            //     let index = fileList.findIndex((f) => f.name === file.name)
            //     fileList.splice(index, 1)
            //     this.$message.error(res.message || '上传失败，请确认上传正确的内容。<br>若多次重试皆不能成功，请联系管理员。')
            // }
            // else {
            //     this.fileList_soft.push({
            //         id: res.id,
            //         url: res.remote_url
            //     })
            // }
        },
        onRemove_soft (val) {
            this.fileList_soft = val.imgs || [];
            // var id = file && file.id;

            // if (!id && file && file.response) {
            //     id = file.response.id;
            // }

            // this.fileList_soft = (this.fileList_soft || []).filter(function (item) {
            //     return String(item.id) !== String(id);
            // });
        },
        handleSoftPreview (file) {
            var previewUrl = '';

            if (typeof file === 'string') {
                previewUrl = file;
            }
            else {
                previewUrl = (file && (file.url || file.remote_url || file.thumbUrl)) || '';
            }

            if (!previewUrl && file && file.response) {
                previewUrl = file.response.remote_url || '';
            }

            if (!previewUrl) {
                this.$message.error('暂无可预览图片');
                return;
            }

            this.softPreview.url = previewUrl;
            this.softPreview.visible = true;
        },
        async getCategories () {
            var vm = this;
            const res = await req
                .send(req.Apis.sales.product.productCategories)
                .fin(() => {});
            if(res.code === 200) {
                vm.categories = res.data
            } else {
                vm.categories = []
            }
            vm.syncPanelState();
        },
        syncPanelState () {
            if (this.isEdit) {
                this.openEditPanel(this.product || {});
                return;
            }
            this.openCreatePanel();
        },
        syncIndustryCategoryMeta (categoryPath) {
            this.productForm.industryText = getCategoryLabelPath(categoryPath, this.categories);
            this.productForm.industry_id = categoryPath && categoryPath.length ? categoryPath[categoryPath.length - 1] : '';
            this.productForm.industry_name = getLeafCategoryLabel(categoryPath, this.categories);
        },
        showCategoryChangeBlockedDialog (message) {
            this.$confirm(message, '提示', {
                confirmButtonText: '我知道了',
                showCancelButton: false,
                type: 'warning'
            }).catch(function () {});
        },
        handleChangeCategory (val) {
            var nextCategory = Array.isArray(val) ? val.slice() : [];
            var originalCategory = Array.isArray(this.originalCategory) ? this.originalCategory.slice() : [];
            var blockedMessage = '';

            if (this.isEdit && originalCategory.length) {
                if (this.productForm.skip_rule === true) {
                    blockedMessage = getCategoryChangeBlockedMessage(originalCategory, nextCategory, this.categories);
                    if (blockedMessage) {
                        this.productForm.category = originalCategory;
                        this.syncIndustryCategoryMeta(originalCategory);
                        this.showCategoryChangeBlockedDialog(blockedMessage);
                        return;
                    }
                }
            }

            this.syncIndustryCategoryMeta(nextCategory);
        },
        openCreatePanel () {
            this.fileList_soft = [];
            this.productForm = createEmptyProductForm();
            this.originalCategory = [];
            this.submitPayload = null;
            this.submitPayloadText = '';
            this.hideDemoPopover();
        },
        openEditPanel (product) {
            this.currentProductId = product.id;
            this.fileList_soft = product.copyright_imgs || [];
            this.productEnabled = true;
            // this.auditRecords = (product.product || []).map(item => buildAuditRecordsFromProduct(item));
            this.auditRecords = buildAuditRecordsFromProduct(product.product || {});
            this.productForm = buildFormFromProduct(product, this.categories);
            this.originalCategory = [].concat(this.productForm.category || []);
            this.syncIndustryCategoryMeta(this.productForm.category);
            this.submitPayload = null;
            this.submitPayloadText = '';
            // this.fileList_soft = (product.copyright_imgs || []).map(function (item, index) {
            //     var url = typeof item === 'string' ? item : (item && item.url) || '';
            //     var id = (item && item.id) || url || index;
            //     var name = url ? (url.split('/').pop() || ('copyright-' + index)) : ('copyright-' + index);

            //     return {
            //         id: id,
            //         name: name,
            //         url: url,
            //         status: 'success'
            //     };
            // });
            this.hideDemoPopover();
        },
        handleCancelEdit () {
            this.submitPayload = null;
            this.submitPayloadText = '';
            this.hideDemoPopover();
            this.$emit('cancel');
        },
        async handleSave () {
            let vm = this;
            if(this.submitLoading) {
                return;
            }
            if(!this.productForm.name) {
                this.$message.error('请先输入产品名称');
                return;
            }
            if(!this.productEnabled){
                vm.productEnabled = true;
            } else {
                try {
                    this.submitLoading = true;

                    var industryMeta = getIndustryPayloadMeta(this.productForm.category, this.categories);

                    this.productForm.industry_name = industryMeta.name || this.productForm.industry_name || this.industryLeafLabel || this.productForm.industryText;
                    if (industryMeta.id) {
                        this.productForm.industry_id = industryMeta.id;
                    }
                    else if (!this.productForm.industry_id) {
                        this.productForm.industry_id = '';
                    }

                    if (this.productForm.skip_rule === true) {
                        if(['fast-app', 'app-download'].includes(this.industryMode) && this.fileList_soft && this.fileList_soft.length === 0) {
                            this.$message.error('请先上传软件著作！');
                            return;
                        }

                        // 行业=快应用时，必须填写DeepLink
                        if (['fast-app'].includes(this.industryMode)) {
                            let androidDpArr = (this.productForm.app_delivery_info && this.productForm.app_delivery_info.android && this.productForm.app_delivery_info.android.deeplinks) || [];
                            if (!androidDpArr.length) {
                            this.$message.error('行业=快应用时，必须填写DeepLink');
                            return;
                            }
                            for (let i = 0, len = androidDpArr.length; i < len; i++) {
                                if (!androidDpArr[i].demo) {
                                    this.$message.error(`第${i + 1}个DeepLink未填写内容`);
                                    return;
                                }
                                if (!androidDpArr[i].schema) {
                                    this.$message.error(`第${i + 1}个DeepLink Schema格式错误`);
                                    return;
                                }
                            }
                        }
                    }

                    this.submitPayload = buildSubmitPayload(this.productForm, this.categories, this.fileList_soft || [], this.industryMode);
                    this.submitPayloadText = JSON.stringify(this.submitPayload, null, 2);

                    let payload = {
                        ...this.submitPayload
                    }
                    if(this.isEdit) {
                        payload.id = this.currentProductId;
                    }

                    const res = await req
                        .send(this.isEdit ? req.Apis.sales.product.productEdit : req.Apis.sales.product.productAdd, payload)
                        .fin(() => {});

                    if(res.code !== 200) {
                        vm.$message.error(res.message);
                    } else {
                        vm.currentProductId = '';
                        if(res.data && res.data.package_duplicate_warning) {
                            vm.$message.warning({
                                message: buildWarningMessageHtml(vm.isEdit ? '编辑成功!' : '新增成功!', res.data.package_duplicate_warning),
                                dangerouslyUseHTMLString: true,
                                duration: 5000
                            });
                        } else {
                            vm.$message.success(vm.isEdit ? '编辑成功!' : '新增成功!');
                        }
                        vm.$emit('success');
                    }
                } finally {
                    this.submitLoading = false;
                }
            }
        },
        // handleDocumentClick (event) {
        //     if (!isTargetInside(event.target, '.pm-schema-link') && !isTargetInside(event.target, '.pm-demo-popover')) {
        //         this.hideDemoPopover();
        //     }
        // },
        auditRecordsSpanMethod (params) {
            var row = params.row;
            var column = params.column;

            if (column.property !== 'productName') {
                return [1, 1];
            }

            if (row.productRowSpan > 0) {
                return [row.productRowSpan, 1];
            }

            return [0, 0];
        },
        addDp (platform) {
            if (platform === 'android') {
                this.productForm.app_delivery_info.android.deeplinks.push(createDpItem('', ''));
                return;
            }
            this.productForm.app_delivery_info.ios.deeplinks.push(createDpItem('', ''));
        },
        handleDpDemoInput (platform, item) {
            if (!item) {
                return;
            }
            item.schema = inferSchemaFromDemo(item.demo);
            if (platform === 'android') {
                this.productForm.app_delivery_info.android.link_type = 'deeplink';
                return;
            }
            this.productForm.app_delivery_info.ios.link_type = 'deeplink';
        },
        handleIosPathModeChange (mode) {
            this.productForm.app_delivery_info.ios.link_type = mode;
            if (mode === 'universal_link') {
                this.productForm.app_delivery_info.ios.deeplinks = [];
                return;
            }
            this.productForm.app_delivery_info.ios.universal_link = '';
            if (!this.productForm.app_delivery_info.ios.deeplinks.length) {
                this.productForm.app_delivery_info.ios.deeplinks.push(createDpItem('', ''));
            }
        },
        removeDp (platform, index) {
            if (platform === 'android') {
                this.productForm.app_delivery_info.android.deeplinks.splice(index, 1);
                return;
            }
            this.productForm.app_delivery_info.ios.deeplinks.splice(index, 1);
        },
        showDemoPopover (event, text) {
            var rect = event.target.getBoundingClientRect();
            var left = Math.min(rect.left, window.innerWidth - 540);
            this.demoPopover.visible = true;
            this.demoPopover.text = text;
            this.demoPopover.left = Math.max(16, left);
            this.demoPopover.top = rect.bottom + 8;
        },
        hideDemoPopover () {
            this.demoPopover.visible = false;
        },
    }
};
</script>

<style lang="less" scoped>
.mf-index-assetManage-productManage {
    position: relative;
    min-height: 100%;
}

.mf-index-assetManage-productManage .pm-shell {
    /* max-width: 1320px; */
    margin: 22px auto 56px;
    display: grid;
    grid-template-columns: 220px 1fr;
    gap: 28px;
    padding: 0 22px;
}

.mf-index-assetManage-productManage .pm-sidebar {
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 3px 10px rgba(40, 54, 86, .06);
    height: 130px;
    padding: 18px 0;
}

.mf-index-assetManage-productManage .pm-side-item {
    height: 48px;
    line-height: 48px;
    padding: 0 26px;
    font-size: 15px;
    color: #4b5565;
    border-left: 3px solid transparent;
    cursor: pointer;
}

.mf-index-assetManage-productManage .pm-side-item.active {
    color: #2f6bff;
    border-left-color: #2f6bff;
    background: #f2f7ff;
    font-weight: 700;
}

.mf-index-assetManage-productManage .pm-main {
    min-width: 0;
}

.mf-index-assetManage-productManage .pm-panel {
    display: block;
}

.mf-index-assetManage-productManage .pm-card {
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 3px 10px rgba(40, 54, 86, .06);
    padding: 26px 40px 32px;
}

.mf-index-assetManage-productManage .pm-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 18px;
}

.mf-index-assetManage-productManage .pm-page-title {
    font-size: 24px;
    font-weight: 800;
    color: #2e3440;
    margin: 0 0 24px;
    padding-bottom: 18px;
    border-bottom: 1px solid #d9e0eb;
}

.mf-index-assetManage-productManage .pm-page-title.is-toolbar {
    margin: 0;
    padding: 0;
    border: 0;
}

.mf-index-assetManage-productManage .pm-note {
    color: #5f6b7c;
    background: #f8faff;
    border: 1px solid #edf1f7;
    border-radius: 6px;
    padding: 12px 14px;
    line-height: 1.6;
    margin-bottom: 14px;
}

.mf-index-assetManage-productManage .pm-query-grid {
    display: grid;
    grid-template-columns: 1fr 1fr auto auto;
    gap: 12px;
    align-items: center;
    padding: 18px;
    background: #f8faff;
    border: 1px solid #edf1f7;
    border-radius: 6px;
    margin-bottom: 22px;
}

.mf-index-assetManage-productManage .pm-search-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 180px;
    color: #8b95a7;
    border: 1px dashed #d7deea;
    border-radius: 6px;
    background: #fbfcff;
}

.mf-index-assetManage-productManage .pm-search-result {
    display: block;
}

.mf-index-assetManage-productManage .pm-section-title {
    color: #2f6bff;
    font-size: 16px;
    font-weight: 800;
    border-left: 3px solid #2f6bff;
    padding-left: 10px;
    margin: 26px 0 16px;
}

.mf-index-assetManage-productManage .pm-result-list {
    display: grid;
    gap: 14px;
}

.mf-index-assetManage-productManage .pm-result-item {
    border: 1px solid #dfe6f2;
    border-radius: 6px;
    background: #fff;
    overflow: hidden;
}

.mf-index-assetManage-productManage .pm-table-wrap {
    width: 100%;
    overflow-x: auto;
}

.mf-index-assetManage-productManage .pm-result-table {
    width: 100%;
    min-width: 900px;
    border-collapse: collapse;
    table-layout: fixed;
}

.mf-index-assetManage-productManage .pm-result-table th,
.mf-index-assetManage-productManage .pm-result-table td {
    border-right: 1px solid #edf1f7;
    border-bottom: 1px solid #edf1f7;
    padding: 12px 18px;
    text-align: left;
    line-height: 1.55;
    word-break: break-word;
    vertical-align: top;
}

.mf-index-assetManage-productManage .pm-result-table th {
    color: #7c8595;
    background: #fbfcff;
    font-weight: 800;
}

.mf-index-assetManage-productManage .pm-result-table tr:last-child td {
    border-bottom: 0;
}

.mf-index-assetManage-productManage .pm-result-table th:last-child,
.mf-index-assetManage-productManage .pm-result-table td:last-child {
    border-right: 0;
}

.mf-index-assetManage-productManage .pm-my-product-table {
    min-width: 1340px;
}

.mf-index-assetManage-productManage .pm-product-name {
    display: block;
    margin-bottom: 6px;
    font-size: 16px;
    font-weight: 800;
    color: #303642;
}

.mf-index-assetManage-productManage .pm-product-industry {
    display: block;
    color: #687386;
    line-height: 1.5;
}

.mf-index-assetManage-productManage .pm-delivery-block {
    display: grid;
    gap: 6px;
}

.mf-index-assetManage-productManage .pm-delivery-item {
    line-height: 1.6;
    color: #4b5565;
    word-break: break-word;
}

.mf-index-assetManage-productManage .pm-delivery-label {
    color: #303642;
    font-weight: 700;
}

.mf-index-assetManage-productManage .pm-delivery-text {
    color: #687386;
}

.mf-index-assetManage-productManage .pm-platform {
    color: #2f6bff;
    font-weight: 800;
}

.mf-index-assetManage-productManage .pm-schema-link {
    color: #2f6bff;
    font-weight: 700;
    cursor: pointer;
}

.mf-index-assetManage-productManage .pm-schema-link:hover {
    text-decoration: underline;
}

.mf-index-assetManage-productManage .pm-text-action {
    color: #2f6bff;
    cursor: pointer;
    white-space: nowrap;
    font-weight: 700;
}

.mf-index-assetManage-productManage .pm-text-action:hover {
    color: #1f56d8;
    text-decoration: underline;
}

.mf-index-assetManage-productManage .pm-reject-reason {
    color: #687386;
    line-height: 1.55;
}

.mf-index-assetManage-productManage .pm-tag {
    display: inline-block;
    padding: 4px 9px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
}

.mf-index-assetManage-productManage .pm-tag.is-pending {
    background: #fff8ed;
    color: #e6a23c;
    border: 1px solid #ffdba7;
}

.mf-index-assetManage-productManage .pm-tag.is-ok {
    background: #eef9e9;
    color: #67c23a;
    border: 1px solid #d6efca;
}

.mf-index-assetManage-productManage .pm-tag.is-reject {
    background: #fff0f0;
    color: #f56c6c;
    border: 1px solid #ffd1d1;
}

.mf-index-assetManage-productManage .pm-tag.is-invalid {
    background: #f2f4f7;
    color: #8b95a7;
    border: 1px solid #dfe4ec;
}

.mf-index-assetManage-productManage .pm-tag.is-view {
    background: #f7f9fc;
    color: #6f7b8e;
    border: 1px solid #dfe4ec;
}

.mf-index-assetManage-productManage .pm-form-row {
    display: flex;
    /* grid-template-columns: 180px minmax(420px, 680px) 1fr; */
    gap: 16px;
    align-items: start;
    margin-bottom: 14px;
}

.mf-index-assetManage-productManage .pm-label {
    width: 130px;
    min-height: 40px;
    line-height: 40px;
    color: #566070;
    font-weight: 600;
    text-align: right;
}

.mf-index-assetManage-productManage .pm-content {
    flex: 1;
}

.mf-index-assetManage-productManage .pm-required {
    color: #f56c6c;
    margin-right: 4px;
}

.mf-index-assetManage-productManage input,
.mf-index-assetManage-productManage textarea {
    width: 100%;
    border: 1px solid #d5dce8;
    border-radius: 4px;
    outline: none;
    background: #fff;
    color: #3d4555;
    font-size: 14px;
}

.mf-index-assetManage-productManage textarea {
    height: 72px;
    resize: vertical;
    line-height: 1.5;
}

.mf-index-assetManage-productManage input:focus,
.mf-index-assetManage-productManage textarea:focus {
    border-color: #2f6bff;
    box-shadow: 0 0 0 2px rgba(79, 143, 247, .12);
}

.mf-index-assetManage-productManage .pm-industry-picker {
    position: relative;
}

.mf-index-assetManage-productManage .pm-industry-input {
    position: relative;
    min-height: 40px;
    border: 1px solid #d5dce8;
    border-radius: 4px;
    background: #fff;
    color: #3d4555;
    padding: 9px 36px 9px 12px;
    cursor: pointer;
    line-height: 20px;
}

.mf-index-assetManage-productManage .pm-industry-input.placeholder {
    color: #a6afbf;
}

.mf-index-assetManage-productManage .pm-industry-input:after {
    content: "";
    position: absolute;
    right: 14px;
    top: 14px;
    width: 9px;
    height: 9px;
    border-right: 1px solid #9ba5b7;
    border-bottom: 1px solid #9ba5b7;
    transform: rotate(45deg);
}

.mf-index-assetManage-productManage .pm-industry-picker.open .pm-industry-input {
    border-color: #2f6bff;
    box-shadow: 0 0 0 2px rgba(47, 107, 255, .12);
}

.mf-index-assetManage-productManage .pm-industry-picker.open .pm-industry-input:after {
    top: 17px;
    transform: rotate(225deg);
}

.mf-index-assetManage-productManage .pm-industry-picker.disabled .pm-industry-input {
    color: #a6afbf;
    background: #f7f9fc;
    cursor: not-allowed;
}

.mf-index-assetManage-productManage .pm-industry-picker.disabled .pm-industry-input:after {
    border-color: #c4ccd9;
}

.mf-index-assetManage-productManage .pm-industry-menu {
    position: absolute;
    left: 0;
    top: 48px;
    z-index: 60;
    width: 720px;
    min-height: 260px;
    display: grid;
    grid-template-columns: 240px 240px 1fr;
    background: #fff;
    border: 1px solid #dfe6f2;
    border-radius: 4px;
    box-shadow: 0 12px 32px rgba(30, 42, 70, .14);
}

.mf-index-assetManage-productManage .pm-industry-col {
    padding: 10px 0;
    border-right: 1px solid #edf1f7;
}

.mf-index-assetManage-productManage .pm-industry-col:last-child {
    border-right: 0;
}

.mf-index-assetManage-productManage .pm-industry-option {
    height: 42px;
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #4d5667;
    font-weight: 600;
    cursor: pointer;
}

.mf-index-assetManage-productManage .pm-industry-option.active {
    color: #2f6bff;
    background: #f3f7ff;
}

.mf-index-assetManage-productManage .pm-industry-option:hover {
    background: #f7faff;
}

.mf-index-assetManage-productManage .pm-industry-option .arrow {
    color: #b2bccb;
    font-size: 18px;
}

.mf-index-assetManage-productManage .pm-industry-rule {
    color: #5f6b7c;
    background: #f8faff;
    border: 1px solid #edf1f7;
    border-radius: 6px;
    padding: 10px 12px;
    margin: 8px 0 18px;
    line-height: 1.6;
}

.mf-index-assetManage-productManage .pm-quick-vendor-area {
    margin-bottom: 18px;
}

.mf-index-assetManage-productManage .pm-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 18px;
    min-height: 40px;
    align-items: center;
}

.mf-index-assetManage-productManage .pm-checkbox-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #3d4555;
    font-weight: 600;
    white-space: nowrap;
}

.mf-index-assetManage-productManage .pm-checkbox-item input {
    width: 16px;
    min-height: 16px;
    height: 16px;
    padding: 0;
}

.mf-index-assetManage-productManage .pm-asset-card {
    border: 1px solid #dfe6f2;
    background: #fff;
    border-radius: 6px;
    padding: 0 0 4px;
    margin-bottom: 14px;
}

.mf-index-assetManage-productManage .pm-asset-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 54px;
    padding: 0 22px;
    margin-bottom: 18px;
    border-bottom: 1px solid #edf1f7;
    font-weight: 800;
}

.mf-index-assetManage-productManage .pm-asset-head-title {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #303642;
}

.mf-index-assetManage-productManage .pm-asset-head-title:before {
    content: "";
    width: 3px;
    height: 16px;
    border-radius: 2px;
    background: #2f6bff;
}

.mf-index-assetManage-productManage .pm-asset-card .pm-form-row {
    grid-template-columns: 180px minmax(480px, 760px) 1fr;
    padding: 0 22px;
}

.mf-index-assetManage-productManage .pm-dp-table {
    width: 100%;
    border-collapse: collapse;
}

.mf-index-assetManage-productManage .pm-dp-table th,
.mf-index-assetManage-productManage .pm-dp-table td {
    border: 1px solid #e2e7f0;
    padding: 10px;
    vertical-align: top;
}

.mf-index-assetManage-productManage .pm-dp-table th {
    color: #7c8595;
    background: #f8faff;
    font-weight: 800;
}

.mf-index-assetManage-productManage .pm-dp-table input,
.mf-index-assetManage-productManage .pm-dp-table textarea {
    min-height: 36px;
}

.mf-index-assetManage-productManage .pm-dp-table textarea {
    height: 58px;
}

.mf-index-assetManage-productManage .pm-dp-add-row td {
    padding: 0;
    background: #fbfcff;
}

.mf-index-assetManage-productManage .pm-dp-add-btn {
    width: 100%;
    height: 42px;
    border: 0;
    border-radius: 0;
    color: #2f6bff;
    background: transparent;
    font-weight: 800;
    text-align: center;
    cursor: pointer;
}

.mf-index-assetManage-productManage .pm-dp-add-btn:hover {
    background: #f3f7ff;
}

.mf-index-assetManage-productManage .pm-dp-delete-btn {
    min-width: 44px;
    height: 32px;
    border: 0;
    border-radius: 4px;
    padding: 0 8px;
    color: #6f7c91;
    background: transparent;
    font-weight: 700;
    cursor: pointer;
}

.mf-index-assetManage-productManage .pm-dp-delete-btn:hover {
    color: #f56c6c;
    background: #fff7f7;
}

.mf-index-assetManage-productManage .pm-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    table-layout: fixed;
}

.mf-index-assetManage-productManage .pm-table th,
.mf-index-assetManage-productManage .pm-table td {
    border: 1px solid #e2e7f0;
    padding: 12px 14px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.55;
    word-break: break-all;
}

.mf-index-assetManage-productManage .pm-table th {
    background: #f8faff;
    color: #7c8595;
    font-weight: 800;
}

.mf-index-assetManage-productManage .pm-asset-table-row {
    display: block;
    margin-bottom: 18px;
}

.mf-index-assetManage-productManage .pm-asset-table-label {
    min-height: auto;
    line-height: 1;
    text-align: left;
    margin-bottom: 12px;
    font-weight: 800;
    color: #566070;
}

.mf-index-assetManage-productManage .pm-asset-table {
    min-width: 940px;
    margin-top: 0;
}

.mf-index-assetManage-productManage .pm-divider {
    height: 1px;
    background: #edf1f7;
    margin: 22px 0;
}

.mf-index-assetManage-productManage .pm-btn-row {
    display: flex;
    gap: 12px;
    margin-top: 26px;
    padding-left: 196px;
}

.mf-index-assetManage-productManage .pm-btn {
    border: 0;
    border-radius: 4px;
    padding: 0 20px;
    height: 40px;
    font-weight: 700;
    cursor: pointer;
}

.mf-index-assetManage-productManage .pm-btn[disabled] {
    cursor: not-allowed;
    opacity: .7;
}

.mf-index-assetManage-productManage .pm-btn-primary {
    background: #2f6bff;
    color: #fff;
}

.mf-index-assetManage-productManage .pm-btn-primary.is-loading {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.mf-index-assetManage-productManage .pm-btn__loading-icon {
    margin-right: 6px;
}

.mf-index-assetManage-productManage .pm-btn-danger {
    color: #f56c6c;
    background: #fff;
    border: 1px solid #ffbcbc;
}

.mf-index-assetManage-productManage .pm-empty {
    color: #8b95a7;
    background: #f8fbff;
    border: 1px dashed #ccd7e8;
    border-radius: 6px;
    padding: 28px;
    text-align: center;
}

.mf-index-assetManage-productManage .pm-demo-popover {
    position: fixed;
    z-index: 120;
    max-width: 520px;
    padding: 12px 14px;
    color: #303642;
    background: #fff;
    border: 1px solid #dfe6f2;
    border-radius: 6px;
    box-shadow: 0 10px 28px rgba(30, 42, 70, .16);
    line-height: 1.6;
    word-break: break-all;
}

.mf-index-assetManage-productManage .pm-demo-popover-title {
    margin-bottom: 6px;
    color: #7c8595;
    font-weight: 800;
}

@media (max-width: 980px) {
    .mf-index-assetManage-productManage .pm-shell {
        grid-template-columns: 1fr;
    }

    .mf-index-assetManage-productManage .pm-sidebar {
        display: none;
    }

    .mf-index-assetManage-productManage .pm-form-row {
        grid-template-columns: 1fr;
    }

    .mf-index-assetManage-productManage .pm-label {
        text-align: left;
    }

    .mf-index-assetManage-productManage .pm-btn-row {
        padding-left: 0;
    }

    .mf-index-assetManage-productManage .pm-query-grid {
        grid-template-columns: 1fr;
    }

    .mf-index-assetManage-productManage .pm-industry-menu {
        width: 100%;
        grid-template-columns: 1fr;
        position: static;
        margin-top: 8px;
    }
}

.mf-index-assetManage-productManage .pm-soft-upload .el-upload-list,
.mf-index-assetManage-productManage .custom-upload-list .el-upload-list,
.mf-index-assetManage-productManage .el-upload-list{
    position: static;
}

</style>
